import Service from "../../Services";

const MembershipBenefit = {
  namespaced : true,
  state : {
    form : {
      id : '',
      branch_id : '',
      detail_en : '',
      detail_th : '',
      rate : '',
      discount_th : '',
      discount_en : '',
      service_en : '',
      service_th : '',
      meeting_room_en : '',
      meeting_room_th : '',
      one_day_pass : '',
      is_publish : true,
    },
  },
  mutations : {
    GET_FORM_MEMBERSHIP_BENEFIT : (state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA : (state)=>{
      state.form = {
        id : '',
        branch_id : '',
        detail_en : '',
        detail_th : '',
        rate : '',
        discount_th : '',
        discount_en : '',
        service_en : '',
        service_th : '',
        meeting_room_en : '',
        meeting_room_th : '',
        one_day_pass : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getMembershipBenefit({commit},page){
      return Service.MembershipBenefitAPI.getMembershipBenefit(page);
    },
    showMembershipBenefit({commit},id){
      return Service.MembershipBenefitAPI.showMembershipBenefit(id);
    },
    saveMembershipBenefit({commit},{id,data}){
      if(id){
        return Service.MembershipBenefitAPI.updateMembershipBenefit(id,data);
      }else{
        return Service.MembershipBenefitAPI.createMembershipBenefit(data);
      }
    },
    deleteMembershipBenefit({commit},id){
      return Service.MembershipBenefitAPI.deleteMembershipBenefit(id);
    },
    setFormMembershipBenefit({commit},res){
      commit("GET_FORM_MEMBERSHIP_BENEFIT",res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default MembershipBenefit
